// Journey update domain models - GET projects/{id}/journey/update (the update panel).

/** The package version the update panel offers, without writing. */
export class ProjectJourneyUpdate {
  /** The version text of the newest newer version, else of the project's own package. */
  packageVersion: string;

  /** The newest newer version's Store description as its author wrote it (HTML); empty when there is none. */
  packageDescription: string;

  /** True when a newer version of the project's own package is available. */
  isNewerVersion: boolean;

  constructor() {
    this.packageVersion = '';
    this.packageDescription = '';
    this.isNewerVersion = false;
  }
}

